// import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import SurgicalItem from "./SurgicalItem"

import classes from '../Shared/Container.module.css'

export default function SurgicalDetails() {
    const activeCase = useSelector(state => state.case.activeCase)

    // const [data, setData] = useState(null)
    // useEffect(() => {
    //     if (activeCase) {
    //         let arr = [...activeCase.surgeries] //no sort
            
    //         setData(arr)
    //     }
    // }, [activeCase])

    return <>
        <div className={`${classes.container} ${classes.container_padding}`}>
            {activeCase && activeCase.surgeries && <table>
                <thead>
                    <tr>
                        <th>Ordered Date</th>
                        <th>Ordered By</th>
                        <th>Area/Description</th>
                        <th>Approval Status</th>
                        <th>Surgical Status</th>
                        <th>Current Stage</th>
                        <th>Scheduled</th>
                        <th>Preformed</th>
                    </tr>
                </thead>
                <tbody>
                    {activeCase.surgeries.map((serviceItem, index) => (
                        <SurgicalItem key={serviceItem.id} itemData={serviceItem} index={index} activeCase={activeCase}/>
                    ))}
                </tbody>
            </table>}
        </div>
    </>
}